import useCompany from './use-company';

const useLogo = () => useCompany().logo;

export default useLogo;
